import React from 'react'

const Version = () => {
  return(
    <div className="version">Memor <span className="version__number">0.3b</span></div>
  );
}

export default Version;